export default "__VITE_ASSET__bd2ba97a__"